import logo from '../../../images/base/logo-brandmark.svg';

window.portalModule.controller 'AppointmentsController', ($scope, $state, $stateParams, $log) ->
  $log = $log.getInstance('AppointmentsController')
  $log.log 'appointments abstract controller loaded.'
  $scope.logo = logo